import { useEffect } from 'react';

const Home = ({ url }) => {
  useEffect(() => {
    // Redirect to the external URL
    window.location.href = url;
}, [url]);

return null; // Render nothing
}

export default Home